var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCircleStroke = function SvgCircleStroke(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 3,
    viewBox: "0 0 10 3",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.789076 0.835083C2.08745 0.29667 3.51035 0 5.00001 0C6.48968 0 7.91257 0.296662 9.21094 0.835075C9.7211 1.04663 9.96317 1.6317 9.75162 2.14186C9.54006 2.65202 8.955 2.89409 8.44484 2.68253C7.38506 2.24306 6.22218 2 5.00001 2C3.77785 2 2.61497 2.24306 1.55519 2.68253C1.04503 2.89409 0.459966 2.65202 0.248412 2.14186C0.0368567 1.6317 0.278917 1.04664 0.789076 0.835083Z",
    fill: "#477EEB"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCircleStroke, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/circle-stroke.44836014.svg";
export { ForwardRef as ReactComponent };